module.exports = __webpack_public_path__ + "img/noodles_main.a533ef9b.png";